module.exports = __webpack_public_path__ + "static/img/rank_1.b124e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_1.png
// module id = iBCI
// module chunks = 1